// login-frontend/src/components/Katie/phaser/scenes/BootScene.js
import Phaser from "phaser";
import QUESTIONS_EN from "../data/questions_en.js"; // fallback only

// Vite-safe asset URLs
const avatar1Url = new URL("/src/assets/Katie/img/avatar_1.png", import.meta.url).href;
const avatar2Url = new URL("/src/assets/Katie/img/avatar_2.png", import.meta.url).href;
const avatar3Url = new URL("/src/assets/Katie/img/avatar_3.png", import.meta.url).href;
const avatar4Url = new URL("/src/assets/Katie/img/avatar_4.png", import.meta.url).href;
const avatar5Url = new URL("/src/assets/Katie/img/avatar_5.png", import.meta.url).href;
const avatar6Url = new URL("/src/assets/Katie/img/avatar_6.png", import.meta.url).href;
const chillMusicUrl = new URL("/src/assets/Katie/audio/chill-music.mp3", import.meta.url).href;
const storyMusicUrl = new URL("/src/assets/Katie/audio/story-music.mp3", import.meta.url).href;
const tts1Url = new URL("/src/assets/Katie/tts/tts-1.mp3", import.meta.url).href;
const tts2Url = new URL("/src/assets/Katie/tts/tts-2.mp3", import.meta.url).href;

export default class BootScene extends Phaser.Scene {
    constructor() {
        super("Boot");
        this._introEl = null;
        this._onResize = null;
    }

    preload() {
        this.cameras.main.setBackgroundColor("#fafafa");
        this.load.image("avatar_1", avatar1Url);
        this.load.image("avatar_2", avatar2Url);
        this.load.image("avatar_3", avatar3Url);
        this.load.image("avatar_4", avatar4Url);
        this.load.image("avatar_5", avatar5Url);
        this.load.image("avatar_6", avatar6Url);
        this.load.audio("bgm_chill", chillMusicUrl);
        this.load.audio("bgm_dramatic", storyMusicUrl);
        this.load.audio("tts_neg", tts1Url);
        this.load.audio("tts_pos", tts2Url);
    }

    create() {
        const ctx = this.registry.get("ctx") || { username: "Guest", lang: "en", kConfig: { normalCount: 5 } };

        // Use whatever questions Katie.jsx set; fallback to EN if missing
        let qs = this.registry.get("questions");
        if (!Array.isArray(qs) || qs.length === 0) {
            qs = QUESTIONS_EN(ctx);
            this.registry.set("questions", qs);
        }

        const { width: W, height: H } = this.scale;
        this.cameras.main.setBackgroundColor("#fafafa");

        // === Canvas card (visual frame only) ===
        const cardW = Math.min(W - 120, 900);
        const cardH = 520;
        const cardX = W / 2;
        const cardY = H / 2;

        // shadow + card
        this.add.rectangle(cardX, cardY + 8, cardW + 28, cardH + 16, 0x000000, 0.06);
        this.add.rectangle(cardX, cardY, cardW, cardH, 0xffffff).setStrokeStyle(2, 0xE5E7EB);
        // top accent
        this.add.rectangle(cardX, cardY - cardH / 2 + 2, cardW, 4, 0x38bdf8).setOrigin(0.5, 0);
        // breadcrumb
        this.add.text(
            cardX - cardW / 2 + 16,
            cardY - cardH / 2 + 14,
            "Assessments  ›  Personality  ›  KATIE Beta",
            { fontFamily: "system-ui", fontSize: "12px", color: "#64748b" }
        ).setOrigin(0, 0.5);

        // === Foreword + Acknowledgment modal (HTML inside same wrapper div) ===
        const parent = this.game.canvas.parentNode;

        const intro = document.createElement("div");
        intro.style.position = "absolute";
        intro.style.left = "50%";
        intro.style.top = "50%";
        intro.style.transform = "translate(-50%, -50%)";
        intro.style.width = "min(92vw, 520px)";
        intro.style.maxWidth = "520px";
        intro.style.padding = "22px";
        intro.style.background = "rgba(255,255,255,0.82)";
        intro.style.backdropFilter = "blur(10px) saturate(140%)";
        intro.style.border = "1px solid #e2e8f0";
        intro.style.borderRadius = "12px";
        intro.style.boxShadow = "0 8px 28px rgba(0,0,0,0.08)";
        intro.style.fontFamily = "system-ui, -apple-system, Roboto";
        intro.style.color = "#0f172a";
        intro.style.lineHeight = "1.6";
        intro.style.textAlign = "left";
        intro.style.zIndex = "10";

        // bilingual intro text
        const isZH = ctx.lang === "zh";
        intro.innerHTML = `
      <div style="display:flex; flex-direction:column; gap:12px;">
        <h2 style="margin:0; font-size:20px;">
          ${isZH ? "欢迎来到 <b>K.A.T.I.E.</b> 性格测试" : "Welcome to the <b>K.A.T.I.E.</b> Personality Test"}
        </h2>
        <p style="margin:0;">
          ${isZH
                ? "这个实验性程序会根据你的回答分析人类情绪特征。该 AI 仍处于 <b>测试阶段</b>，其生成的结果可能并不完全准确。"
                : "This experimental program analyzes human emotional traits based on your answers. The AI is still in <b>beta</b>—its generated personality outcomes may be incomplete or inaccurate."
            }
        </p>
        <p style="margin:0;">
          ${isZH
                ? "继续测试即表示你已知晓，结果仅供娱乐和研究使用，你的回答可能会用于系统的校准。"
                : "By continuing, you acknowledge that results are for entertainment and research purposes only, and your responses may be used to calibrate the system."
            }
        </p>
        <label style="display:flex; align-items:center; gap:8px; margin-top:4px;">
          <input type="checkbox" id="ack" />
          <span>${isZH ? "我已了解并愿意继续。" : "I understand and wish to proceed."}</span>
        </label>
        <div style="display:flex; gap:10px; margin-top:6px;">
          <button id="startBtn" disabled
            style="padding:10px 16px; background:#cbd5e1; border:0; border-radius:10px; color:#fff; cursor:not-allowed; font-size:15px;">
            ${isZH ? "开始测试" : "Start Test"}
          </button>
          <button id="exitBtn"
            style="padding:10px 14px; background:#f1f5f9; border:1px solid #e2e8f0; border-radius:10px; color:#0f172a; cursor:pointer; font-size:15px;">
            ${isZH ? "取消" : "Cancel"}
          </button>
        </div>
        <small style="color:#64748b;">${isZH ? "感谢你参与 KATIE 项目。" : "Thank you for contributing to Project KATIE."}</small>
      </div>
    `;
        parent.appendChild(intro);
        this._introEl = intro;

        const ack = intro.querySelector("#ack");
        const startBtn = intro.querySelector("#startBtn");
        const exitBtn = intro.querySelector("#exitBtn");

        ack.addEventListener("change", () => {
            if (ack.checked) {
                startBtn.disabled = false;
                startBtn.style.background = "#0ea5e9";
                startBtn.style.cursor = "pointer";
            } else {
                startBtn.disabled = true;
                startBtn.style.background = "#cbd5e1";
                startBtn.style.cursor = "not-allowed";
            }
        });

        startBtn.addEventListener("click", () => {
            try {
                const bgm = this.sound.add("bgm_chill", { loop: true, volume: 0.6 });
                bgm.play();
                this.registry.set("bgm", bgm);
            } catch { }

            this._removeIntro();
            this.cameras.main.once(Phaser.Cameras.Scene2D.Events.FADE_OUT_COMPLETE, () => {
                this.scene.start("Test");
            });
            this.cameras.main.fadeOut(180, 255, 255, 255);
        });

        exitBtn.addEventListener("click", () => {
            const bgm = this.registry.get("bgm");
            if (bgm && bgm.isPlaying) {
                try { bgm.stop(); } catch { }
            }
            this._removeIntro();
            const ctx2 = this.registry.get("ctx");
            if (ctx2 && typeof ctx2.onExit === "function") {
                try { ctx2.onExit(); } catch { }
            }
            this.game.destroy(true);
        });

        this._onResize = () => { };
        window.addEventListener("resize", this._onResize);
    }

    _removeIntro() {
        if (this._introEl) {
            try { this._introEl.remove(); } catch { }
            this._introEl = null;
        }
        if (this._onResize) {
            window.removeEventListener("resize", this._onResize);
            this._onResize = null;
        }
    }

    shutdown() { this._removeIntro(); }
    destroy() { this._removeIntro(); }
}







